// extracted by mini-css-extract-plugin
export default {"switch":"iz1HEXLgwnA35351plx4","slider":"uptHNrNgvmVt7fQC3xyP"};